<template>
  <el-row>
    <el-col :span="16">
      <el-card class="box-card">
        <div slot="header" class="flex justify-between">
          <span>{{ $t('privilege.privilegeGroup') }}</span>
          <el-button 
            type="primary" 
            size="small" 
            class="float-right" 
            @click="openPrivilegeGroupModel">
            <i class="el-icon-plus"></i>
            {{ $t('privilege.add') }}
          </el-button>
        </div>
        <el-table
          :data="privilegeInfo.privilegeGroups"
          style="width: 100%"
          border
          stripe>
          <el-table-column
            prop="name"
            :label="$t('privilege.name')"
            align="center">
            <template slot-scope="scope">
              <span class="link-type" @click="notifyQueryPrivilege(scope.row)">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="pgId"
            :label="$t('privilege.code')"
            align="center">
            <template slot-scope="scope">
              <span class="link-type" @click="notifyQueryPrivilege(scope.row)">
                {{ scope.row.pgId }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('privilege.createTime')"
            align="center">
            <template slot-scope="scope">
              {{ dateFormat(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('privilege.operation')"
            align="center"
            width="180">
            <template slot-scope="scope">
              <el-button-group v-if="scope.row.storeId != '9999'">
                <el-button 
                  size="mini" 
                  @click="openEditPrivilegeGroupModel(scope.row)">
                  {{ $t('privilege.edit') }}
                </el-button>
                <el-button 
                  size="mini" 
                  type="danger"
                  @click="openDeletePrivilegeGroupModel(scope.row)">
                  {{ $t('privilege.delete') }}
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination-container"
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="currentPage"
          :page-size="pageSize"
          @current-change="handleCurrentChange">
        </el-pagination>
      </el-card>
    </el-col>

    <el-col :span="8" class="animated fadeInRight">
      <el-card class="box-card">
        <div slot="header" class="flex justify-between">
          <h2>{{ privilegeInfo._currentPgName }}-{{ $t('privilege.privilege') }}</h2>
        </div>
        <div class="mail-box">
          <el-tree
            ref="privilegeTree"
            :data="treeData"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            @check="handleCheckChange">
          </el-tree>
        </div>
      </el-card>
    </el-col>

    <add-privilege-group ref="addPrivilegeGroup"></add-privilege-group>
    <edit-privilege-group ref="editPrivilegeGroup"></edit-privilege-group>
    <delete-privilege-group ref="deletePrivilegeGroup"></delete-privilege-group>
  </el-row>
</template>

<script>
import { getPrivilegeGroupList, getPrivilegeList } from '@/api/privilege/privilegeApi'
import { getShopId } from '@/api/shop/shopApi'
import { dateFormat } from '@/utils/dateUtil'
import AddPrivilegeGroup from '@/components/addPrivilegeGroup/addPrivilegeGroup'
import EditPrivilegeGroup from '@/components/editPrivilegeGroup/editPrivilegeGroup'
import DeletePrivilegeGroup from '@/components/deletePrivilegeGroup/deletePrivilegeGroup'

export default {
  name: 'Privilege',
  components: {
    AddPrivilegeGroup,
    EditPrivilegeGroup,
    DeletePrivilegeGroup
  },
  data() {
    return {
      privilegeInfo: {
        _currentPgId: "",
        _currentPgName: "",
        _pName: '',
        _currentStoreId: "9999",
        _privileges: [],
        privilegeGroups: []
      },
      total: 0,
      currentPage: 1,
      pageSize: 15,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      }
    }
  },
  created() {
    this.loadPrivilegeGroup()
  },
  methods: {
    dateFormat,
    async loadPrivilegeGroup() {
      try {
        const res = await getPrivilegeGroupList()
        this.privilegeInfo.privilegeGroups = res.data
        if (res.data.length > 0) {
          this.notifyQueryPrivilege(res.data[0])
        }
      } catch (error) {
        console.error('Failed to load privilege groups:', error)
      }
    },
    async _loadPrivilege(pgId) {
      try {
        let shopId = await getShopId();
        const res = await getPrivilegeList({
          pgId,
          name: this.privilegeInfo._pName,
          shopId
        })
        this.privilegeInfo._privileges = res.data
        this.treeData = this._doJsTreeData(res.data)
      } catch (error) {
        console.error('Failed to load privileges:', error)
      }
    },
    notifyQueryPrivilege(pGroup) {
      this.privilegeInfo._currentPgId = pGroup.pgId
      this.privilegeInfo._currentPgName = pGroup.name
      this.privilegeInfo._currentStoreId = pGroup.storeId
      this._loadPrivilege(pGroup.pgId)
    },
    openPrivilegeGroupModel() {
      this.$refs.addPrivilegeGroup.open()
    },
    openEditPrivilegeGroupModel(pGroup) {
      this.$refs.editPrivilegeGroup.open(pGroup)
    },
    openDeletePrivilegeGroupModel(pGroup) {
      this.$refs.deletePrivilegeGroup.open(pGroup)
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadPrivilegeGroup()
    },
    handleCheckChange(data, checked) {
      const checkedKeys = this.$refs.privilegeTree.getCheckedKeys()
      const selectPrivileges = checkedKeys
        .filter(key => key.startsWith('p_'))
        .map(key => key.substring(2))
      
      if (checked.checkedKeys.length > checkedKeys.length) {
        this.deletePrivilege(selectPrivileges)
      } else {
        this.addPrivilegeToPrivilegeGroup(selectPrivileges)
      }
    },
    _doJsTreeData(privileges) {
      console.log(privileges)
      // 实现树形数据处理逻辑
      // ...
    },
    async addPrivilegeToPrivilegeGroup(selectPrivileges) {
      console.log(selectPrivileges)
      // 实现添加权限逻辑
      // ...
    },
    async deletePrivilege(selectPrivileges) {
      console.log(selectPrivileges)
      // 实现删除权限逻辑
      // ...
    }
  }
}
</script>

<style scoped>
.link-type {
  color: #409EFF;
  cursor: pointer;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.mail-box {
  min-height: 400px;
}
</style>